<div class="py-4 modalDiv">
    <div *ngFor="let comment of commentHistory; let i=index;" class="mt-2 mb-2">
        <label>
            <span class="commentNo">{{i+1}}. </span><span class="commentTxt">{{comment}}</span>
        </label>
    </div>
</div>
